import React, { useEffect, useState,useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../style.css';

const NewsBanner = () => {
  const tittle =["Stay tuned for our latest updates! "];
  const messages = [
    ""
    
  ];

  const [index, setIndex] = useState(0);
  const textRef = useRef(null);
  const [duration, setDuration] = useState(30);

 useEffect(() => {

 const baseSpeed = 0.1; // smaller = faster, larger = slower
  const duration = messages.length * baseSpeed;

    /*if (textRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const containerWidth = textRef.current.parentElement.offsetWidth;

      // speed factor: bigger number = slower scroll
      const speedFactor = 100; 
      const calculatedDuration = Math.max(
        (textWidth / containerWidth) * speedFactor,
        20 // minimum 20s
      );

      setDuration(calculatedDuration);
      
    }*/
  }, []);

  return (
    <div className="news-banner shadow">
      

      <div
        ref={textRef}
        className="news-text"
        style={{ animationDuration: `${duration}s` }}
      >
       <span className="fw-bold fs-5">{tittle}</span> 
        <span className="fs-5">{messages}</span>
      </div>
    </div>
  );
};

export default NewsBanner;
